export default "__VITE_ASSET__BJFc5jda__"